// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__A9PZ6","fade":"Modal_fade__oNNla","fade-in":"Modal_fade-in__-ZVBr","overlay":"Modal_overlay__dgaNt","close":"Modal_close__jU2fm","body":"Modal_body__x9YMA"};